import styled from 'styled-components';
import { COLOR_WHITE, COLOR_ORANGE } from '../../../assets/styles/colors';
import { BP_TABLET_MAX } from '../../../assets/styles/breakpoints';

export default styled.div`
  display: flex;
  height: 50px;
  width: 100%;
  border: solid 1px transparent;
  border-radius: 14px;
  background-image: linear-gradient(#f7f7f8, #f7f7f8), linear-gradient(-90deg, #fab535, #f7931e);
  background-origin: border-box;
  background-clip: content-box, border-box;

  button {
    border-radius: 12px;
    padding: 10px 10px 11px 10px;
    font-size: 18px;
    border: none;
    background: none;
    background-image: transparent;
    color: ${COLOR_ORANGE};
    font-weight: bold;
    width: 100%;
    flex: 1;

    &.active {
      background-image: linear-gradient(-90deg, #fab535, #f7931e);
      color: ${COLOR_WHITE};
      box-shadow: 0 4px 15px 0 rgba(47, 46, 65, 0.15);
      margin-top: -1px;
      height: 50px;
    }
  }

  @media (max-width: ${BP_TABLET_MAX}px) {
    display: flex;
    height: auto;
    flex-direction: column;
    width: 100%;

    button {
      min-width: auto;
      max-width: 100%;
      width: 100%;
      &.active {
        margin-top: 0px;
      }
    }
  }
`;
